import { FaBtc, FaCog } from "react-icons/fa";
import { IRouteConfig } from "@lib/types/Routes";
import { ROUTES } from "@lib/constants";
import { IoWallet } from "react-icons/io5";
import { SiQuicklook } from "react-icons/si";
import { TbHeartRateMonitor, TbZoomMoney } from "react-icons/tb";
import { GrList } from "react-icons/gr";
import { PiGitPullRequestLight } from "react-icons/pi";
import { HiMiniQueueList, HiMiniUserGroup } from "react-icons/hi2";
import { AppContext } from "@lib/types";
import { FaPeopleGroup } from "react-icons/fa6";
import { AiOutlineFileText } from "react-icons/ai";
import { BiSolidDashboard } from "react-icons/bi";

const customerRoutesConfig: IRouteConfig[] = [
  {
    id: "dashboards",
    title: "dashboards",
    messageId: "sidebar.dashboards",
    type: "group",
    icon: <BiSolidDashboard />,
    showInBottomNav: false,
    children: [
      {
        id: ROUTES.CUSTOMER.DASHBOARD,
        url: ROUTES.CUSTOMER.DASHBOARD,
        title: "Customer Dashboard",
        messageId: "sidebar.customer.dashboard",
        icon: <BiSolidDashboard />,
        type: "item",
        showInBottomNav: true,
      },
    ],
  },

  {
    id: "menu",
    title: "Menu",
    messageId: "sidebar.menu",
    type: "group",
    icon: <HiMiniQueueList />,
    children: [
      {
        id: AppContext.CUSTOMER_LEAD,
        title: "WhiteLabel Lead Transactions",
        messageId: "sidebar.whiteLabelLeadTransactions",
        type: "collapse",
        icon: <FaPeopleGroup />,
        children: [
          {
            id: ROUTES.CUSTOMER_LEAD.LIST,
            url: ROUTES.CUSTOMER_LEAD.LIST,
            title: "White Label Lead",
            messageId: "sidebar.whiteLabelLeadTransactions.whiteLabelLead",
            icon: <GrList />,
            type: "item",
            children: [
              {
                id: ROUTES.CUSTOMER_LEAD.DETAIL,
                url: ROUTES.CUSTOMER_LEAD.DETAIL,
                paramKey: ROUTES.URL_PARAMS.CUSTOMER_LEAD_ID,
                title: "White Label Lead Detail",
                messageId: "sidebar.customerLeadDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.SEND_BYTE_WALLETS.LIST,
            url: ROUTES.SEND_BYTE_WALLETS.LIST,
            title: "Wallets",
            messageId: "sidebar.whiteLabelLeadTransactions.wallets",
            icon: <IoWallet />,
          },

          {
            id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
            url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
            title: "Wallet Pool",
            messageId: "sidebar.whiteLabelLeadTransactions.walletAccounts",
            icon: <FaBtc />,
            type: "item",
            children: [
              {
                id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
                url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
                paramKey: ROUTES.URL_PARAMS.WALLET_ID,
                title: "Wallet",
                messageId: "common.wallet",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS.LIST,
            url: ROUTES.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS.LIST,
            title: "Blockchain Payment Requests",
            messageId:
              "sidebar.whiteLabelLeadTransactions.blockchainPaymentRequests",
            icon: <PiGitPullRequestLight />,
          },

          {
            id: ROUTES.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENTS.LIST,
            url: ROUTES.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENTS.LIST,
            title: "Blockchain Payments",
            messageId: "sidebar.whiteLabelLeadTransactions.blockchainPayments",
            icon: <TbZoomMoney />,
          },
        ],
      },
      {
        id: "menu.myInvoices",
        title: "My Invoices",
        messageId: "sidebar.myInvoices",
        type: "collapse",
        icon: <AiOutlineFileText />,
        children: [
          {
            id: ROUTES.CUSTOMER.INVOICE.LIST,
            url: ROUTES.CUSTOMER.INVOICE.LIST,
            title: "Invoices",
            messageId: "sidebar.whiteLabelTransactions.invoices",
            icon: <AiOutlineFileText />,
          },
          {
            id: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENT_REQUEST.LIST,
            url: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENT_REQUEST.LIST,
            title: "Blockchain Payment Requests",
            messageId: "sidebar.blockchainPaymentRequest",
            icon: <PiGitPullRequestLight />,
          },
          {
            id: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
            url: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
            title: "Blockchain Payments",
            messageId: "sidebar.whiteLabelTransactions.blockchainPayments",
            icon: <TbZoomMoney />,
          },
          // {
          //   id: ROUTES.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
          //   url: ROUTES.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
          //   title: "Cash Payment History",
          //   messageId: "sidebar.cashPaymentHistory",
          //   icon: <GrMoney />,
          //   type: "item",
          // },
        ],
      },
    ],
  },

  // {
  //   id: "payments",
  //   title: "payments",
  //   messageId: "sidebar.customer.payments",
  //   type: "group",
  //   icon: <BiSolidDashboard />,
  //   children: [
  //     {
  //       id: ROUTES.SEND_BYTE_WALLETS.LIST,
  //       url: ROUTES.SEND_BYTE_WALLETS.LIST,
  //       title: "Wallets",
  //       messageId: "sidebar.whiteLabelLeadTransactions.wallets",
  //       icon: <IoWallet />,
  //     },
  //     {
  //       id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
  //       url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
  //       title: "Wallet Pool",
  //       messageId: "sidebar.whiteLabelLeadTransactions.walletAccounts",
  //       icon: <FaBtc />,
  //       type: "item",
  //       children: [
  //         {
  //           id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
  //           url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
  //           paramKey: ROUTES.URL_PARAMS.WALLET_ID,
  //           title: "Wallet",
  //           messageId: "common.wallet",
  //           type: "item",
  //           dontShowInSidebar: true,
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    id: "monitoring",
    title: "monitoring",
    messageId: "sidebar.monitoring",
    type: "group",
    icon: <SiQuicklook />,
    children: [
      {
        id: ROUTES.MONITORING.AUDIT_LOGS.LIST,
        url: ROUTES.MONITORING.AUDIT_LOGS.LIST,
        title: "monitoring",
        messageId: "sidebar.auditLogs",
        icon: <TbHeartRateMonitor />,
        type: "item",
        children: [
          {
            id: ROUTES.MONITORING.AUDIT_LOGS.DETAIL,
            url: ROUTES.MONITORING.AUDIT_LOGS.DETAIL,
            paramKey: ROUTES.URL_PARAMS.AUDIT_LOG_ID,
            title: "Audit Log Detail",
            messageId: "sidebar.auditLogDetail",
            type: "item",
            dontShowInSidebar: true,
          },
        ],
      },
    ],
  },

  {
    id: "systemManagement",
    title: "System Management",
    messageId: "sidebar.systemManagement",
    type: "group",
    icon: <FaCog />,
    children: [
      {
        id: ROUTES.MANAGER.LIST,
        url: ROUTES.MANAGER.LIST,
        title: "Managers",
        messageId: "sidebar.managers",
        icon: <HiMiniUserGroup />,
        type: "item",
        children: [
          {
            id: ROUTES.MANAGER.DETAIL,
            url: ROUTES.MANAGER.DETAIL,
            paramKey: ROUTES.URL_PARAMS.MANAGER_ID,
            title: "Manager Detail",
            messageId: "sidebar.managerDetail",
            type: "item",
            dontShowInSidebar: true,
          },
        ],
      },
    ],
  },

  {
    id: ROUTES.CUSTOMER.SETTINGS,
    url: ROUTES.CUSTOMER.SETTINGS,
    title: "Settings",
    messageId: "sidebar.customer.settings",
    icon: <FaCog />,
    type: "item",
    dontShowInSidebar: true,
    showInBottomNav: true,
  },
];

export default customerRoutesConfig;
